import AtmMntcHstr from '@/views/customerCare/AtmMntcHstr'
import AtmMntcHstrInsert from '@/views/customerCare/AtmMntcHstrInsert'
import AtmMntcHstrUpdate from '@/views/customerCare/AtmMntcHstrUpdate'
import AtmMntcSchd from '@/views/customerCare/AtmMntcSchd'
import AtmMntcSchdUpdate from '@/views/customerCare/AtmMntcSchdUpdate'
import AtmObstHstrMain from '@/views/customerCare/AtmObstHstrMain'
import AtmObstHstrInsert from '@/views/customerCare/AtmObstHstrInsert'

export default [
  {
    path: '/customerCare/atmMntcHstr',
    name: 'AtmMntcHstr',
    component: AtmMntcHstr,
    meta: {
      authRequired: true,
      desc: 'ATM 정기유지보수'
    }
  },
  {
    path: '/customerCare/atmMntcHstrInsert',
    name: 'AtmMntcHstrInsert',
    component: AtmMntcHstrInsert,
    meta: {
      authRequired: true,
      desc: 'ATM 정기유지보수 등록'
    }
  },
  {
    path: '/customerCare/atmMntcHstrUpdate',
    name: 'AtmMntcHstrUpdate',
    component: AtmMntcHstrUpdate,
    meta: {
      authRequired: true,
      desc: 'ATM 정기유지보수 수정'
    }
  },
  {
    path: '/customerCare/atmMntcSchd',
    name: 'AtmMntcSchd',
    component: AtmMntcSchd,
    meta: {
      authRequired: true,
      desc: 'ATM 정기유지보수-스케줄'
    }
  },
  {
    path: '/customerCare/atmMntcSchdUpdate',
    name: 'AtmMntcSchdUpdate',
    component: AtmMntcSchdUpdate,
    meta: {
      authRequired: true,
      desc: 'ATM 정기유지보수(스케쥴) 수정'
    }
  },
  {
    path: '/customerCare/atmObstHstrMain',
    name: 'AtmObstHstrMain',
    component: AtmObstHstrMain,
    meta: {
      authRequired: true,
      desc: 'ATM 장애이력관리'
    }
  },
  {
    path: '/customerCare/atmObstHstr',
    name: 'AtmObstHstr',
    component: AtmObstHstrMain,
    meta: {
      authRequired: true,
      desc: 'ATM 장애이력관리 목록'
    }
  },
  {
    path: '/customerCare/atmObstHstrInsert',
    name: 'AtmObstHstrInsert',
    component: AtmObstHstrInsert,
    meta: {
      authRequired: true,
      desc: 'ATM 장애이력관리 등록'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/customerCare/index.js